import {
  LayoutDashboard, LifeBuoy, CalendarDays, ClipboardCheck, Briefcase, Repeat, CalendarOff,
  CalendarX2, UsersRound, BookUser, ShieldAlert, Home, Receipt, SlidersHorizontal,
  FileText, MessageSquare, History, CalendarRange, HeartHandshake, Users, Wallet, Settings, IdCard, FileCheck2, Building2, Car, Package, ShieldCheck, StickyNote, FileSignature, Mail, MailCheck, KeyRound, Banknote, Globe2, Sparkles, Inbox, FolderTree, BookOpen, Landmark, Crown, Newspaper, UserCog,
} from "lucide-react";

// Module map for the office desk. Each module groups existing pages. An item
// shows when its gate passes (usually a permission from backend/permissions.py);
// a module shows when its own gate passes and it has at least one item.
export const MODULES = [
  {
    key: "rostering",
    label: "Rostering",
    description: "Shifts, roster board & approvals",
    icon: CalendarRange,
    accent: "#bf3b4f",
    gate: () => true,
    items: [
      { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, end: true, gate: (can) => can.has("roster.view") },
      { to: "/roster", label: "Roster Board", icon: CalendarDays, gate: (can) => can.has("roster.view") },
      { to: "/timesheets", label: "Approval Workbench", icon: ClipboardCheck, gate: (can) => can.has("timesheets.view") },
      { to: "/job-board", label: "Job Board", icon: Briefcase, gate: (can) => can.has("roster.view") },
      { to: "/sms", label: "SMS", icon: MessageSquare, gate: (can) => can.has("sms.send") },
      { to: "/bulk-email", label: "Bulk Email", icon: Mail, gate: (can) => can.has("bulk_email.send") },
      { to: "/templates", label: "Shift Templates", icon: Repeat, gate: (can) => can.has("templates.view") },
      { to: "/leave", label: "Leave", icon: CalendarOff, gate: (can) => can.has("leave.view") },
      { to: "/unavailability", label: "Unavailability", icon: CalendarX2, gate: (can) => can.has("unavailability.view") },
    ],
  },
  {
    key: "ndis",
    label: "NDIS Management",
    description: "Participants, incidents & SIL",
    icon: HeartHandshake,
    accent: "#2f6f6b",
    gate: () => true,
    items: [
      { to: "/ndis-management", label: "Dashboard", icon: LayoutDashboard, gate: (can) => can.has("participants.view") },
      { to: "/participants", label: "Participants", icon: UsersRound, gate: (can) => can.has("participants.view") },
      { to: "/directory", label: "Directory", icon: BookUser, gate: (can) => can.has("participants.view") },
      { to: "/sms", label: "SMS", icon: MessageSquare, gate: (can) => can.has("sms.send") },
      { to: "/bulk-email", label: "Bulk Email", icon: Mail, gate: (can) => can.has("bulk_email.send") },
      { to: "/incidents", label: "Incidents", icon: ShieldAlert, gate: (can) => can.has("incidents.view") },
      // Staff who can't see the incident list still need somewhere to log one.
      { to: "/incidents/new", label: "Log an Incident", icon: ShieldAlert, gate: (can) => can.has("incidents.create") && !can.has("incidents.view") },
      { to: "/properties", label: "Properties (SIL)", icon: Home, gate: (can) => can.has("properties.view") },
      { to: "/staff-profiles", label: "Staff Profiles", icon: IdCard, gate: (can) => can.has("staff_profiles.view") },
      { to: "/document-compliance-report", label: "Document Read Report", icon: FileCheck2, gate: (can) => can.has("participant_docs.view") },
    ],
  },
  {
    key: "hr",
    label: "HR",
    description: "Leave & availability",
    icon: Users,
    accent: "#b8742a",
    gate: (can) => can.has("hr.view"),
    items: [
      { to: "/hr/staff", label: "Staff Records", icon: IdCard, gate: (can) => can.has("hr.view") },
      { to: "/leave", label: "Leave", icon: CalendarOff, gate: (can) => can.has("leave.view") },
      { to: "/unavailability", label: "Unavailability", icon: CalendarX2, gate: (can) => can.has("unavailability.view") },
    ],
  },
  {
    key: "accounts",
    label: "Accounts",
    description: "Invoicing & billing",
    icon: Wallet,
    accent: "#2f7a52",
    gate: (can) => can.has("invoicing.view", "payroll.view"),
    items: [
      { to: "/invoicing", label: "Invoicing", icon: Receipt, gate: (can) => can.has("invoicing.view") },
      { to: "/payroll", label: "Payroll", icon: Banknote, gate: (can) => can.has("payroll.view") },
    ],
  },
  {
    key: "organisation",
    label: "Organisation",
    description: "Vehicle, asset & insurance registers",
    icon: Building2,
    accent: "#3b5b8c",
    gate: (can) => can.has("org.view"),
    items: [
      { to: "/organisation", label: "Overview", icon: Building2, end: true, gate: (can) => can.has("org.view") },
      { to: "/organisation/vehicles", label: "Vehicle Register", icon: Car, gate: (can) => can.has("org.view") },
      { to: "/organisation/assets", label: "Asset Register", icon: Package, gate: (can) => can.has("org.view") },
      { to: "/organisation/insurances", label: "Insurance Register", icon: ShieldCheck, gate: (can) => can.has("org.view") },
    ],
  },
  {
    key: "documents",
    label: "Documents",
    description: "Policies, procedures & company documents",
    icon: FolderTree,
    accent: "#6b4f8a",
    gate: (can) => can.docs,
    items: [
      { to: "/documents/policies", label: "Policies & Procedures", icon: BookOpen },
      { to: "/documents/company", label: "Company Documents", icon: FileText },
      { to: "/documents/ask", label: "Policies AI", icon: Sparkles },
      { to: "/documents/approvals", label: "Approvals", icon: ClipboardCheck, gate: (can) => can.management },
      { to: "/documents/compliance", label: "Compliance check", icon: ShieldCheck, gate: (can) => can.management },
      { to: "/documents/ndis-commission", label: "NDIS Commission", icon: Newspaper, gate: (can) => can.management },
      { to: "/documents/management", label: "Management Team", icon: Landmark, gate: (can) => can.management },
      { to: "/documents/executive", label: "Executive Team", icon: Crown, gate: (can) => can.executive },
    ],
  },
  {
    key: "admin",
    label: "Admin Settings",
    description: "Rules, documents & config",
    icon: Settings,
    accent: "#475569",
    gate: () => true,
    items: [
      // ── General & System ──────────────────────────────────────────────────
      { to: "/settings/general", label: "General", icon: Globe2, group: "General & System", gate: (can) => can.has("settings.general") },
      { to: "/settings/auth", label: "Authentication", icon: KeyRound, group: "General & System", gate: (can) => can.has("settings.users") },
      { to: "/settings/roles", label: "Roles & Permissions", icon: UserCog, group: "General & System", gate: (can) => can.has("settings.users") },
      { to: "/settings/support-access", label: "Support access", icon: LifeBuoy, group: "General & System", gate: (can) => can.has("support.grant") },
      { to: "/settings/holidays", label: "Public Holidays", icon: CalendarDays, group: "General & System", gate: (can) => can.has("settings.holidays") },
      { to: "/settings/ai", label: "AI Settings", icon: Sparkles, group: "General & System", gate: (can) => can.has("settings.ai") },
      // ── Communications ────────────────────────────────────────────────────
      { to: "/settings/email", label: "Email Senders", icon: Mail, group: "Communications", gate: (can) => can.has("settings.email") },
      { to: "/settings/email-queue", label: "Email Queue", icon: Inbox, group: "Communications", gate: (can) => can.has("settings.email_queue") },
      { to: "/settings/reminders", label: "Reminder Emails", icon: MailCheck, group: "Communications", gate: (can) => can.has("settings.reminders") },
      { to: "/settings/messaging", label: "SMS Messaging", icon: MessageSquare, group: "Communications", gate: (can) => can.has("settings.messaging") },
      // ── Rostering & Workforce ─────────────────────────────────────────────
      { to: "/settings/rostering", label: "Rostering Rules", icon: SlidersHorizontal, group: "Rostering & Workforce", gate: (can) => can.has("settings.rostering") },
      { to: "/settings/hr-documents", label: "HR Document Types", icon: IdCard, group: "Rostering & Workforce", gate: (can) => can.has("settings.hr_document_types") },
      { to: "/settings/hr-note-types", label: "HR Note Types", icon: StickyNote, group: "Rostering & Workforce", gate: (can) => can.has("settings.hr_note_types") },
      // ── Documents & Compliance ────────────────────────────────────────────
      { to: "/settings/documents", label: "Document Builder", icon: FileText, group: "Documents & Compliance", gate: (can) => can.has("settings.document_builder") },
      { to: "/settings/document-compliance", label: "Document Compliance", icon: ShieldCheck, group: "Documents & Compliance", gate: (can) => can.has("settings.document_compliance") },
      { to: "/settings/sa-templates", label: "SA Templates", icon: FileSignature, group: "Documents & Compliance", gate: (can) => can.has("settings.sa_templates") },
      { to: "/settings/office-note-types", label: "Office Note Types", icon: StickyNote, group: "Documents & Compliance", gate: (can) => can.has("settings.office_note_types") },
      { to: "/settings/audit-prep", label: "Audit Prep AI", icon: FileCheck2, group: "Documents & Compliance", gate: (can) => can.has("settings.audit_prep") },
      { to: "/settings/documents-ai", label: "Documents AI", icon: Sparkles, group: "Documents & Compliance", gate: (can) => can.has("settings.documents_ai") },
      // ── Finance ───────────────────────────────────────────────────────────
      { to: "/settings/accounts", label: "Accounts Settings", icon: Receipt, group: "Finance", gate: (can) => can.has("settings.accounts") },
      { to: "/settings/payroll", label: "Payroll Export", icon: Banknote, group: "Finance", gate: (can) => can.has("settings.payroll") },
      // ── System Tools ──────────────────────────────────────────────────────
      { to: "/audit", label: "Audit Log", icon: History, group: "System Tools", gate: (can) => can.has("system.audit_log") },
      { to: "/issues", label: "Issue Tracker", icon: ShieldAlert, group: "System Tools", gate: (can) => can.has("system.issue_tracker") },
    ],
  },
];

// Menus follow what the person may see (can.sees): a Look only support session sees Admin Settings without
// being able to change them; buttons on the pages still use can.has.
const seeing = (can) => (can && can.sees ? { ...can, has: can.sees } : can);

export function moduleItems(mod, can) {
  const c = seeing(can);
  return mod.items.filter((it) => !it.gate || it.gate(c));
}

export function accessibleModules(can) {
  return MODULES.filter((m) => m.gate(seeing(can)) && moduleItems(m, can).length > 0);
}

// Which module owns a path (longest-prefix match, only among accessible modules).
export function moduleForPath(pathname, can) {
  const mods = accessibleModules(can);
  let best = null, bestLen = -1;
  for (const m of mods) {
    for (const it of moduleItems(m, can)) {
      if (pathname === it.to || pathname.startsWith(it.to + "/")) {
        if (it.to.length > bestLen) { best = m; bestLen = it.to.length; }
      }
    }
  }
  return best || mods[0] || null;
}

// Active module: prefer the one the user explicitly entered (for pages shared
// across modules, e.g. Leave in both Rostering and HR), else derive from path.
export function currentModule(pathname, can) {
  const mods = accessibleModules(can);
  const stored = typeof window !== "undefined" ? sessionStorage.getItem("activeModule") : null;
  if (stored) {
    const m = mods.find((x) => x.key === stored);
    if (m && moduleItems(m, can).some((it) => pathname === it.to || pathname.startsWith(it.to + "/"))) return m;
  }
  return moduleForPath(pathname, can);
}
